const styles = (theme) => ({
  addButton: {
    height: 40,
    width: 40,
    marginRight: 15,
    background: '#69B64A',
    color: 'white',
    borderRadius: '50%',
  },
  addButtonText: {
    textTransform: 'uppercase',
  },
  avatar: {
    marginRight: 15,
  },
  block: {
    display: 'block',
  },
  iconRight: {
    position: 'absolute',
    right: 0,
  },
  companyInfoButtons: {
    display: 'flex',
    justifyContent: 'center',
  },
  companyInfoFields: {
    minWidth: 350,
    marginBottom: 60,
  },
  companyInfoHeader: {
    marginTop: 10,
    fontSize: 16,
    color: 'gray',
  },
  companyInfoTitle: {
    margin: '20px 0px',
  },
  contentScroll: {
    display: 'flex',
    overflowY: 'scroll',
    flexDirection: 'column',
  },
  flexAndSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  listItem: {
    minHeight: 74,
  },
  listItemSubtext: {
    color: 'gray',
    fontSize: 14,
  },
  logo: {
    width: 140,
    height: 30,
  },
  logoUpload: {
    maxWidth: '140px',
    height: '100px',
  },
  pencilIcon: {
    position: 'absolute',
  },
  pencilIconContainer: {
    height: 50,
    width: 50,
  },
  publishIcon: {
    color: 'black',
    marginRight: 20,
  },
  noLogoContainer: {
    backgroundColor: 'lightGrey',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 60,
    width: 60,
  },
  logoBorder: {
    border: '2px dashed green',
    boxSizing: 'content-box',
  },
  hiddenBorder: {
    border: '2px solid white',
    boxSizing: 'content-box',
  },
  logoPlaceholder: {
    fontWeight: 800,
    color: 'grey',
    cursor: 'default',
    textTransform: 'uppercase',
  },
  uploadButton: {
    marginLeft: 20,
    paddingRight: 40,
    marginTop: 12,
    borderColor: 'grey',
  },
  clearLogoButtonContainer: {
    height: 8,
    width: 8,
    cursor: 'pointer',
    right: 10,
    bottom: 10,
    backgroundColor: 'lightgrey',
  },
  clearLogoButton: {
    position: 'absolute',
  },
  centeredMessage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    '& .MuiPaginationItem-root': {
      color: '#69B64A',
      borderColor: '#69B64A',
      margin: '4px',
    },
    marginTop: '12px',
  },
  rideDetailsTableRow: {
    marginTop: 30,
  },
  rideDetailsAvatar: {
    marginRight: 40,
    width: 60,
    height: 60,
  },
  rideDetailsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  rideDetailsLeftColumn: {
    color: 'gray',
    textAlign: 'right',
    fontWeight: 'normal',
    verticalAlign: 'top',
    width: 100,
  },
  rideDetailsRightColumn: {
    '& div': {
      marginBottom: 10,
    },
    textAlign: 'left',
    fontWeight: 500,
    paddingLeft: 20,
  },
  rideDetailsTable: {
    borderCollapse: 'separate',
    borderSpacing: '0 35px',
  },
  search: {
    display: 'flex',
    position: 'sticky',
    marginTop: 10,
    marginBottom: 5,
  },
  searchBar: {
    width: 'inherit',
    flex: 1,
  },
  skeletonAvatar: {
    height: 40,
    width: 40,
    marginRight: 15,
  },
  textAlignCenter: {
    textAlign: 'center',
  },
});

export default styles;
